import React from "react";
import SparkleIcon from "~/icons/svg/SparkleIcon.svg?react";
import BarChartAiIcon from "~/icons/svg/BarChartAiIcon.svg?react";
import {isDashgenAppName} from "~/pages/chat-agent/utils/agentDatabag";

/**
 * Avatar icon for an agent `app_name`: DashGen shows the Dashboards module icon, every other agent the
 * Atlas sparkle. Shown in an `IconWrapper` with `color="atlas"`, like every icon of the turn head.
 */
export function agentIcon(appName: string | undefined): React.ReactElement {
    return isDashgenAppName(appName) ? <BarChartAiIcon/> : <SparkleIcon/>;
}
